import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { getLatestFirmware } from '../../api/nodes';
import { MonitorFirmware } from './types';

// Define the initial state as an empty array of MonitorFirmware
const initialState: MonitorFirmware[] = [];

export const firmwareSlice = createSlice({
    name: 'firmware',
    initialState,
    reducers: {
        // Update the state with the payload, replacing the entire state array
        getFirmware: (state, action: PayloadAction<MonitorFirmware[]>) => {
            return action.payload;
        },
    }
});

// Export the action creator
export const { getFirmware } = firmwareSlice.actions;

// Define an async thunk action creator to fetch firmware data
export const findFirmware = (id: string | number): AppThunk => async (dispatch, getState) => {
    console.log("Getting monitor firmware information");
    const { user } = getState();

    try {
        const data = await getLatestFirmware(user.api_key, id);
        
        // Dispatch the getFirmware action with the fetched data
        dispatch(getFirmware(data));
    } catch (err) {
        // Dispatch the getFirmware action with the error message if fetching fails
        dispatch(getFirmware(err.toString()));
    }
};

export default firmwareSlice.reducer;
